import { FormProvider } from "react-hook-form";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { GoogleInput } from "@/components/ui/form";
import { Calendar } from "../appointment-form/calendar/calendar";

export const FilterForm = ({
    methods,
    onSubmit,
    onChange,
    onClear,
    startDate,
    endDate,
    ref,
}) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="flex w-full items-center"
            >
                <Card className="w-full gap-y-8">
                    <div className="space-y-4">
                        <div className="flex w-full items-center justify-between border-b border-gray-300 pb-4 md:pb-5">
                            <p className="text-xl/5 font-semibold text-darkgreen-300">
                                Location
                            </p>
                            <Button
                                type="button"
                                variant="secondary"
                                name="clearClinicians"
                                size="sm"
                                onClick={onClear}
                            >
                                Clear
                            </Button>
                        </div>
                        <div className="mx-auto">
                            <GoogleInput
                                name="findAddress"
                                label="Where?"
                                hideLabel={true}
                                placeholder="Where?"
                                setValue={methods.setValue}
                                onChange={onSubmit}
                                ref={ref}
                            />
                        </div>
                    </div>
                    <div className="space-y-4">
                        <div className="flex w-full items-center justify-between border-b border-gray-300 pb-4 md:pb-5">
                            <p className="text-xl/5 font-semibold text-darkgreen-300">
                                Availability
                            </p>
                        </div>
                        <div className="mx-auto">
                            <Calendar
                                selectRange={true}
                                onChange={onChange}
                                value={[startDate, endDate]}
                            />
                        </div>
                    </div>
                </Card>
            </form>
        </FormProvider>
    );
};
